import config from "@sg-protect/runtime-config";
import { InternalServerError, type ModuleRegisterFunction, PublicLayout } from "@sg-protect/shell";
import { Outlet } from "react-router";
import { msalInstance } from "./api/auth/msal.ts";
import { injectMockMsal } from "./api/mocks/msal.mock.tsx";
import { AuthenticatedProviders } from "./components/layout/AuthenticatedProviders.tsx";
import { GlobalProviders } from "./components/layout/GlobalProviders.tsx";
import { MigrateRootRedirect } from "./components/MigrateRootRedirect.tsx";
import { Routes } from "./constants.ts";
import { privateRoutes, publicRoutes } from "./routes.tsx";

const registerRoutes: ModuleRegisterFunction = runtime => {
    runtime.registerRoute({
        path: Routes.root,
        element: (
            <GlobalProviders>
                <Outlet />
            </GlobalProviders>
        ),
        errorElement: <InternalServerError homeUrl={config.get().home.baseUrl} />,
        children: [
            {
                index: true,
                element: <MigrateRootRedirect />
            },
            {
                element: (
                    <PublicLayout>
                        <Outlet />
                    </PublicLayout>
                ),
                children: publicRoutes
            },
            {
                element: (
                    <AuthenticatedProviders>
                        <Outlet />
                    </AuthenticatedProviders>
                ),
                handle: {
                    isMigrateAssessmentFlow: true
                },
                children: privateRoutes
            }
        ]
    });
};

const registerMsw: ModuleRegisterFunction = async runtime => {
    if (runtime.isMswEnabled) {
        const requestHandlers = (await import("./api/msw.ts")).handlers;

        // Tags handlers so DUMP_MSW_MOCKS=true (pnpm dev-msw:dump) can report which module each mock came from.
        requestHandlers.forEach(handler => Object.assign(handler, { mockModule: "migrate" }));

        runtime.registerRequestHandlers(requestHandlers);
        injectMockMsal(msalInstance);
    }
};

export const register: ModuleRegisterFunction = async runtime => {
    await registerMsw(runtime);

    await registerRoutes(runtime);
};
